// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"856":"8777cbf4","860":"f9c9890e"}[chunkId] + ".js";
};